import { ModuleFeature } from '../DynamicModule';
export const AlertsFeature = ({ alertContent }: Content.TopBanner) => {
	return (
		<>
			{alertContent?.items.map((alertModule, index) => {
				return (
					<ModuleFeature
						key={index}
						contentModule={alertModule}
						area="alertsSection"
						className={index === 0 && 'u-top-margin-important--none u-bottom-margin-important--none'}
					/>
				);
			})}
		</>
	);
};
